import "datejs";

export const createColumn = (
  field,
  headerName,
  width,
  type = "string",
  renderCell = null,

) => {

  const dateFieldPatterns = [
    'date',
    'datum',
    'time',
    'created',
    'updated',
    'timestamp'
  ];
  
  const isDateField = dateFieldPatterns.some(pattern => 
    field.toLowerCase().includes(pattern.toLowerCase())
  );


  const defaultDateFormatter = ({ value, row }) => {
    try {
      if (!value) return '';
      const date = new Date(value);
      
      // ✅ للحجوزات المميزة: عرض التوقيت بالضبط كما محفوظ (UTC)
      // ✅ للحجوزات العادية: عرض التوقيت كما هو محفوظ (UTC)
      if (row && row.isSpecial) {
        // عرض التوقيت UTC للحجوزات المميزة (بدون تحويل)
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        return `${day}.${month}.${year} ${hours}:${minutes}`;
      } else {
        // عرض التوقيت UTC للحجوزات العادية (كما كان من قبل)
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = date.getUTCFullYear();
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        return `${day}.${month}.${year} ${hours}:${minutes}`;
      }
    } catch (e) {
      console.error(`Error formatting date for field ${field}:`, e);
      return value; // Return original value if formatting fails
    }
  };

  const booleanRenderer = (params) =>
    params.value ? (
      <span style={{ color: "green", fontSize: "1.2rem" }}>✓</span>
    ) : (
      <span style={{ color: "red", fontSize: "1.2rem" }}>✗</span>
    );

  return {
    field: field,
    headerName: headerName,
    width: width,
    type: type,
    headerAlign: "center",
    align: "center",
    headerClassName: "super-app-theme--header",

    ...(renderCell && { renderCell }),
    ...(['isCanceled', 'isPaid', 'isAGift', 'isVerified', 'isActive', 'isDeleted'].includes(field) && {
      renderCell: booleanRenderer
    }),
    ...(isDateField && !renderCell && {
      renderCell: defaultDateFormatter
    })
  };
};